import React from 'react';
import {useSelector} from "react-redux";
import {rolesConstants} from "mindsets-js-sdk";

export default function () {
    const me = useSelector(state => state.me);
    if (me && me.persona === rolesConstants.ROLE_TEACHER && me.school) {
        return (
            <div className="flex-row user-info-field">
                <div className="user-info-field-label">School</div>
                <div>{me.school.name}</div>
            </div>
        );
    }

    return null;
}
